export const LOGIN = "LOGIN";
export const POPULATE_SESSION = "POPULATE_SESSION";
export const POPULATE_GAME = "POPULATE_GAME";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const POPULATE_DOMAIN = "POPULATE_DOMAIN";
export const POPULATE_LOCALE = "POPULATE_LOCALE";
export const POPULATE_USER = "POPULATE_USER";
export const POPULATE_TOKEN = "POPULATE_TOKEN";
export const POPULATE_AZC_ACCESS_TOKEN = "POPULATE_AZC_ACCESS_TOKEN";
export const POPULATE_AZC_REFRESH_TOKEN = "POPULATE_AZC_REFRESH_TOKEN";
export const LOGOUT = "LOGOUT";
export const SSO_LOGIN = "SSO_LOGIN";
export const NOTIFICATION_TOTAL = "NOTIFICATION_TOTAL";
export const NOTIFICATION_LIST = "NOTIFICATION_LIST";
